'use client';

import { baseLocale, type Locale } from '@bells/i18n/runtime';
import { FaqCategoryResponse } from '@bells/schema/models/faq';
import { Tabs, TabsList, TabsTrigger } from '@bells/ui/components/tabs';
import { useRouter } from 'next/navigation';

export default function HelpCategorySwitcher({
  categories,
  locale,
  slug,
}: {
  categories: FaqCategoryResponse[];
  slug: string;
  locale: Locale;
}) {
  const router = useRouter();
  return (
    <div className='flex items-center justify-center'>
      <Tabs
        onValueChange={(val) => {
          router.push(
            locale == baseLocale ? `/hilfe/${val}` : `/${locale}/help/${val}`
          );
        }}
        defaultValue={slug}
        className='mb-4 flex h-auto w-full flex-wrap'
      >
        <TabsList className='flex h-auto flex-wrap gap-2 bg-transparent'>
          {categories.map((df) => {
            return (
              <TabsTrigger
                className='m-0 rounded-full border border-primary p-0 px-4 py-2 text-primary data-[state=active]:bg-primary data-[state=active]:text-primary-foreground'
                value={df.slug}
                key={df.slug}
              >
                {df.title}
              </TabsTrigger>
            );
          })}
        </TabsList>
      </Tabs>
    </div>
  );
}
